export enum WidgetLayoutEnum {
  FULLSCREEN = "fullscreen",
  POPUP = "popup"
}
